import React from 'react'
import { Control, FieldErrors } from 'react-hook-form'
import BaseQuestion from '../base-question'
import { renderContentItems } from 'utilities/contentful'
import s from '../styles.module.css'

interface FreeFormSkipQuestionProps {
  question: {
    id: number
    text: string
    isRequired?: boolean
    type: string
    richTextNote?: {
      content: any[]
    }
  }
  // RHF mode
  control?: Control<any>
  errors?: FieldErrors<any>
  // Zustand mode (not used for freeFormSkip, but included for consistency)
  value?: any
  error?: string
  onChange?: (value: any) => void
}

const FreeFormSkipQuestion: React.FC<FreeFormSkipQuestionProps> = ({
  question,
  control,
  errors,
  error,
}) => {
  // FreeFormSkip doesn't need form control, but we check for RHF mode for error display
  const isRHFMode = !!control && !!errors

  return (
    <BaseQuestion
      question={question}
      control={isRHFMode ? control : undefined}
      errors={isRHFMode ? errors : undefined}
      error={!isRHFMode ? error : undefined}>
      {question.richTextNote && question.richTextNote.content && (
        <div className={s.richTextNote}>
          {renderContentItems(question.richTextNote.content)}
        </div>
      )}
    </BaseQuestion>
  )
}

export default FreeFormSkipQuestion
